import { useRef } from 'react';

const ComponentTextSelectionOptimized = ({ children }) => {
  const downInsideSel = useRef(false);
  const dragging = useRef(false);
  const start = useRef({ x: 0, y: 0 });

  const handlePointerDown = (e) => {
    const sel = window.getSelection();
    dragging.current = false;
    start.current = { x: e.clientX, y: e.clientY };

    // register only when not editing
    if (sel && !sel.isCollapsed && sel.containsNode(e.target, true)) {
      downInsideSel.current = true;
    } else {
      downInsideSel.current = false;
    }
  };

  const handlePointerMove = (e) => {
    if (e.buttons !== 1) return; // only while pressed
    const dx = e.clientX - start.current.x;
    const dy = e.clientY - start.current.y;
    if (Math.hypot(dx, dy) > 3) dragging.current = true; // small threshold
  };

  const handlePointerUp = () => {
    if (downInsideSel.current && !dragging.current) {
      const sel = window.getSelection();
      if (sel) sel.removeAllRanges(); // deselect on simple click
    }
    downInsideSel.current = false;
    dragging.current = false;
  };
  return (
    <div onPointerDown={handlePointerDown} onPointerMove={handlePointerMove} onPointerUp={handlePointerUp}>
      {children}
    </div>
  );
};

export default ComponentTextSelectionOptimized;
